/*
 * � 2020 Microsoft. All rights reserved.
 */

define('Solitaire/GameResult',{
    /// <summary>
    /// No game result yet.
    /// </summary>
    None: 0,
        /// <summary>
        /// The user won the game! Hooray!
        /// </summary>
    Win: 1,
        /// <summary>
        /// The user lost because the game decided there were no more moves left.
        /// </summary>
    NoMoreMoves: 2,
        /// <summary>
        /// The user lost because they were playing a timed game and they were out of time.
        /// </summary>
    OutOfTime: 3
});
